import Loader from "./Loader";

/**
 * Classe che gestisce il componente lightbox, quando clicko su un'immagine mi apre
 * un overlay che la contiene.
 * @param {string} wrapperTemplateId Id del template per la lightbox
 * @param {string} wrapperClass Classe del wrapper da utilizzare
 */
export default class LigthBox {
    constructor(wrapperTemplateId = "lightbox-template", wrapperClass = ".js-lightbox-wrapper"){
        this.shown = false;
        this.wrapperTemplateId = wrapperTemplateId;
        this.wrapperClass = wrapperClass;
        this.clonedTemplate = null;
    }
    /**
     * Funzione che mostra o nasconde la lightbox
     * @param {string} imageSource link dell'immagine
    */
    toggleLigthbox(imageSource = ''){
        //Se non trova l'id del template
        if(!this.wrapperTemplateId){
            console.error('wrapperTemplateId not set correctly, the value was null or undefined', this.wrapperTemplateId);
            return;
        }
        const template = document.getElementById(this.wrapperTemplateId);
        //Se l'id del template è impostato correttamente ma non trova l'elemento si ferma
        if(!template){
            console.error('The template was not found, the value was null or undefined', template);
            return;
        }

        this.shown = !this.shown;

        if(!this.shown){
            this.clonedTemplate.remove();
            return;
        }

        //Clono il template
        const clonedLightboxWrapper = template.cloneNode(true);
        clonedLightboxWrapper.id = '';
        
        document.body.append(clonedLightboxWrapper);
        clonedLightboxWrapper.showModal();

        clonedLightboxWrapper.addEventListener('close', () => {
            this.shown = false;
            clonedLightboxWrapper.remove();
        })
        this.clonedTemplate = clonedLightboxWrapper;
        
        clonedLightboxWrapper.addEventListener('click', () => {
            this.clonedTemplate.close();
            this.shown = false;
            return;
        });

        try{
            const image = clonedLightboxWrapper.querySelector('.js-ligthbox-image');
            image.src = imageSource;
            image.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        }catch(exception){
            console.log(exception);
        }
    }
}
